import axios from 'axios';
import qs from 'query-string';

// fixme заменить axios на axiosBeelineRequest import { axiosBeelineRequest } from "@beef/utils";
import { requestConfig } from "../constants";

/**
 * Проверяет достпуна ли квартира для подключения
 * @param {object} request Объект запроса
 * @param {string} request.city
 * @param {number} request.cityId
 * @param {string} request.street
 * @param {number | null | string} request.streetId
 * @param {string} request.house
 * @param {number | null | string} request.houseId
 * @param {boolean | undefined} request.isConnected
 * @param {string} request.flat
 */
function checkConnection(request) {
  var requestData = qs.stringify(request);
  return axios.post('/customers/products/home/request/checkconnection/', requestData, requestConfig);
}
export default checkConnection;